import { MAX_PROMPT_LENGTH, MODEL_VERSION, Q4_MAX_PROMPT_LENGTH } from '@/app/constants';

export const getPromptMaxLength = (modelVersion: string): number =>
  modelVersion === MODEL_VERSION.Q4 ? Q4_MAX_PROMPT_LENGTH : MAX_PROMPT_LENGTH;
